import { TABLE_OFFER_INJECT } from '@/utils/consts'
import TableOfferInject from '@/components/ui/table/Inject/TableOfferInject'

export class AllTableInject {
  constructor() {
    this[TABLE_OFFER_INJECT] = new TableOfferInject()
  }
}
